import { store } from '@redux/store';
import { filter, map } from 'rxjs';
import { segmentTrack } from 'features/segment';
import determineReferrerSourceManufacturerPages from 'utils/referrerSource';
import { bodyClick$, onPageComplete$ } from 'pages/manufacturerBrandLanding/redux/observables';
import getBrandPageUrl from "../../services/manufacturerBrandCardService";

const totalBrands = document.querySelectorAll('[data-brand-card]').length;

/**
 * Retrieves the closest manufacturer card element from the event target.
 * @function getManufacturerCard
 * @param {Event} event - The DOM event object
 * @returns {Element|null} The manufacturer card element or null if not found
 */
const getManufacturerCard = (event) => event.target.closest('[data-brand-card]');

/**
 * Triggers a Segment event when featured brands are loaded on the page.
 * Dispatches a 'featured_brands_view' event with page type and source URL.
 * @function triggerFeaturedBrandLoad
 * @returns {void}
 */
const triggerFeaturedBrandLoad = () => {

  const customProperties = {
    page_type: 'featured_brands_directory',
    entry_source: determineReferrerSourceManufacturerPages(document.referrer),
  };

  store.dispatch(segmentTrack({ eventName: 'featured_brands_view', customProperties }));
};

onPageComplete$.subscribe(triggerFeaturedBrandLoad);

/**
 * Triggers a Segment event when a featured brand is clicked.
 * Dispatches a 'featured_brands_events' event with click target information.
 * @function triggerOnClickFeaturedBrand
 * @returns {void}
 * @todo Add feature_brand_name, feature_brand_position,
 * destination_url, and total_brands_rendered properties
 */
const triggerOnClickFeaturedBrand = (card) => {
  const dataset = card.dataset;
  const parsedIndex = parseInt(dataset.index, 10) || 0;

  const customProperties = {
    page_type: 'featured_brands_directory',
    feature_brand_name: dataset.brandName,
    feature_brand_position: parsedIndex + 1,
    destination_url: getBrandPageUrl(card),
    total_brands_rendered: totalBrands
  };

  store.dispatch(segmentTrack({ eventName: 'featured_brands_card_click', customProperties, skipDebounce: true }));
};

bodyClick$.pipe(map(getManufacturerCard), filter(Boolean)).subscribe(triggerOnClickFeaturedBrand);